import { Address } from '../pages/types';

export const formatCountryCode = (countryCode: string): string => {
  const countryMap: { [key: string]: string } = {
    US: 'United States',
    CA: 'Canada',
  };
  return countryMap[countryCode] || countryCode;
};

export const getAddressLines = (address: Address): string[] => {
  if (!address) return [];
  const { address1, address2, city, state, zip, country } = address;
  const firstLine = `${address1}${address2 ? ', ' + address2 : ''}`;
  const secondLine = `${city}, ${state.toLocaleUpperCase()} ${zip}`;
  const thirdLine = formatCountryCode(country);
  return [firstLine, secondLine, thirdLine];
};

export const formatAddress = (
  address: Partial<Address> &
    Required<Pick<Address, 'address1' | 'city' | 'state' | 'country' | 'zip'>>
): string => {
  if (!address) return '';
  const { address1, address2, city, state, zip, country } = address;
  const formattedCountry = formatCountryCode(country);
  return [address1, address2, city, state, zip, formattedCountry].filter(Boolean).join(', ');
};
